import axiosInstance from "../axiosInstance";

export const wmsService = {
  create: async (data) => {
    try {
      let response = await axiosInstance.post("/warehouse", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetch: async (client_id, limit, skip, signal, searchKey) => {
    try {
      let api = `/warehouse?$limit=${limit || 15}&$skip=${skip || 0}&$populate=provider`;
      if (client_id) {
        api += `&client_id=${client_id}`;
      }
      if (searchKey) {
        const q = encodeURIComponent(searchKey);
        api += `&$or[0][name][$search]=${q}&$or[1][warehouse_code][$search]=${q}`;
      }
      let response = await axiosInstance.get(api, signal);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  edit: async (data, id) => {
    try {
      let response = await axiosInstance.patch(`/warehouse/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async (id) => {
    try {
      let response = await axiosInstance.delete(`/warehouse/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchProvider: async (limit, skip, searchValue) => {
    try {
      let response = await axiosInstance.get(
        `/provider?$limit=${limit || 15}&$skip=${skip || 0}&type=WMS`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
